export default "__VITE_ASSET__CIt2RmnF__"